import React from 'react'
import DOMPurify from 'isomorphic-dompurify';
import QRCode from "react-qr-code";
import { renderToStaticMarkup } from 'react-dom/server'
const rawHTML = `
<div id="receipt">
    
<center id="top">
  <div class="info"> 
    <h1>測試頁 測試頁 測試頁</h1>
  </div><!--End Info-->
</center><!--End InvoiceTop-->

<div id="bot">

                <div id="table">
                    <table>
                        <tr class="tabletitle">
                            <td class="item"><h2>測試</h2></td>
                            <td class="Hours"><h2>測試</h2></td>
                            <td class="Rate"><h2>測試</h2></td>
                        </tr>

                        <tr class="service">
                            <td class="tableitem"><p class="itemtext">Testing</p></td>
                            <td class="tableitem"><p class="itemtext">10</p></td>
                            <td class="tableitem"><p class="itemtext">$1.00</p></td>
                        </tr>

                        <tr class="service">
                            <td class="tableitem"><p class="itemtext">Testing</p></td>
                            <td class="tableitem"><p class="itemtext">10</p></td>
                            <td class="tableitem"><p class="itemtext">$1.00</p></td>
                        </tr>

                        <tr class="service">
                            <td class="tableitem"><p class="itemtext">Testing</p></td>
                            <td class="tableitem"><p class="itemtext">10</p></td>
                            <td class="tableitem"><p class="itemtext">$1.00</p></td>
                        </tr>



                    </table>
                </div><!--End Table-->


            </div><!--End InvoiceBot-->
</div><!--End Invoice-->
`

const rawHTMLBackup = `

<div id="receipt">
    
<center id="top">
  <div class="info"> 
    <h2>Lemondice</h2>
    <img class="px-4 py-2" src="./logo.png">
  </div><!--End Info-->
</center><!--End InvoiceTop-->

<div class="flex flex-col justify-center items-center text-xl tracking-wide">
<span>A002</span>
<span>2位/PAX</span>
</div>

<div id="mid">
  <div class="info">
    <h2>Contact Info</h2>
    <p> 
        Address : street city, state 0000</br>
        Email   : JohnDoe@gmail.com</br>
        Phone   : 555-555-5555</br>
    </p>
  </div>
</div><!--End Invoice Mid-->
<div class="my-5">
{qrcode}
</div>
<div id="bot">

                <div id="table">
                    <table>
                        <tr class="tabletitle">
                            <td class="item"><h2>Item</h2></td>
                            <td class="Hours"><h2>Qty</h2></td>
                            <td class="Rate"><h2>Sub Total</h2></td>
                        </tr>

                        <tr class="service">
                            <td class="tableitem"><p class="itemtext">Communication</p></td>
                            <td class="tableitem"><p class="itemtext">5</p></td>
                            <td class="tableitem"><p class="itemtext">$375.00</p></td>
                        </tr>

                        <tr class="service">
                            <td class="tableitem"><p class="itemtext">Asset Gathering</p></td>
                            <td class="tableitem"><p class="itemtext">3</p></td>
                            <td class="tableitem"><p class="itemtext">$225.00</p></td>
                        </tr>

                        <tr class="service">
                            <td class="tableitem"><p class="itemtext">Design Development</p></td>
                            <td class="tableitem"><p class="itemtext">5</p></td>
                            <td class="tableitem"><p class="itemtext">$375.00</p></td>
                        </tr>

                        <tr class="service">
                            <td class="tableitem"><p class="itemtext">Animation</p></td>
                            <td class="tableitem"><p class="itemtext">20</p></td>
                            <td class="tableitem"><p class="itemtext">$1500.00</p></td>
                        </tr>

                        <tr class="service">
                            <td class="tableitem"><p class="itemtext">Animation Revisions</p></td>
                            <td class="tableitem"><p class="itemtext">10</p></td>
                            <td class="tableitem"><p class="itemtext">$750.00</p></td>
                        </tr>


                        <tr class="tabletitle">
                            <td></td>
                            <td class="Rate"><h2>tax</h2></td>
                            <td class="payment"><h2>$419.25</h2></td>
                        </tr>

                        <tr class="tabletitle">
                            <td></td>
                            <td class="Rate"><h2>Total</h2></td>
                            <td class="payment"><h2>$3,644.25</h2></td>
                        </tr>

                    </table>
                </div><!--End Table-->

                <div id="legalcopy">
                    <p class="legal my-2"><strong>Thank you for your business!</strong> </p><p class="legal">Payment is expected within 31 days; please process this invoice within that time. There will be a 5% interest charge per month on late invoices. 
                    </p>
                </div>

            </div><!--End InvoiceBot-->
</div><!--End Invoice-->

`

const ReceiptHtml = () => {
    const qrcode = <QRCode
        size={256}
        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        value={'https://lemondices.com/https://lemondices.com/https://lemondices.com/https://lemondices.com/https://lemondices.com/https://lemondices.com/https://lemondices.com/'}
        viewBox={`0 0 256 256`}
    />;

    return (<div>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(rawHTML.replace('{qrcode}', renderToStaticMarkup(qrcode))) }} />
    </div>)
}

export default ReceiptHtml